import React from 'react'

import * as S from './styles'

/**
 * @typedef {'xs' | 'sm' | 'md' | 'lg' | 'xl' | number} RadiusType
 */

/**
 * @typedef {Object} CardProps
 * @property {RadiusType} [radius]
 * @property {React.ReactNode} children
 */

/**
 * @param {CardProps} props
 */
export default function Card({ radius = 'lg', children }) {
  return (
    <S.Card shadow="sm" padding="sm" radius={radius} withBorder>
      {children}
    </S.Card>
  )
}
